import { useEffect, useState } from "react";
import { Container, Row, Col, DropdownButton, Dropdown } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useGetAllTranslationsForKey, useGetAvailableLanguages } from "../../hooks/global/Languages";

import DatePicker from "../global/DatePicker";
import moment from "moment";

function ModuleReportSelector({ modules, company, onUpdated }) {
  const { t, i18n } = useTranslation();
  const availableLan = useGetAvailableLanguages();

  const {getTranslationObject} = useGetAllTranslationsForKey();

  const [currentModule, setCurrentModule] = useState(null);
  const [baseDate, setBaseDate] = useState();
  const [compareDate, setCompareDate] = useState(null);
  const [isUpdate, setIsUpdate] = useState(false);


  const lang = availableLan.find(element => element === i18n.language) || availableLan[0];

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);

    const selectedModuleId = params.get('selectedModule');
    const createdAfterTimestamp = params.get('createdAfter');
    const createdBeforeTimestamp = params.get('createdBefore');
    const compareAfterTimestamp = params.get('compareAfter');
    const compareBeforeTimestamp = params.get('compareBefore');

    if (selectedModuleId && modules && company) {
      const moduleFromId = modules.find(module => module.id === selectedModuleId) || {  ...company,id: "COMPANY", };
      setCurrentModule(moduleFromId);
    } else {
      setCurrentModule({  ...company,id: "COMPANY", });
    }

    if (createdAfterTimestamp && createdBeforeTimestamp) {
      setBaseDate({
        startDate: moment(parseInt(createdAfterTimestamp, 10)),
        endDate: moment(parseInt(createdBeforeTimestamp, 10)),
      });
    } else {
      setBaseDate({ startDate: moment().subtract(1, 'months'), endDate: moment() });
    }

    if (compareAfterTimestamp && compareBeforeTimestamp) {
      setCompareDate({
        startDate: moment(parseInt(compareAfterTimestamp, 10)),
        endDate: moment(parseInt(compareBeforeTimestamp, 10)),
      });
    } else {
      setCompareDate({ startDate: null, endDate: null });
    }

  }, [modules, company]);

  const updateURL = () => {
    const queryParams = new URLSearchParams({
      selectedModule: currentModule?.id || 'ALL',
      createdAfter: baseDate.startDate?.valueOf(),
      createdBefore: baseDate.endDate?.valueOf(),
      compareAfter: compareDate.startDate?.valueOf(),
      compareBefore: compareDate.endDate?.valueOf()
    }).toString();
    const currentUrl = window.location.pathname;
    const newUrl = `${currentUrl}?${queryParams}`;
    window.history.pushState({ path: newUrl }, '', newUrl);
  }

  useEffect(() => {
    if (isUpdate) updateURL();
    onUpdated({ baseDate, compareDate, currentModule })
  }, [baseDate, compareDate, currentModule]);

  const handleBaseDate = (e) => {
    if (e.startDate !== null || e.endDate !== null) {
      setIsUpdate(true);
      setBaseDate(e);
    }
  }
  const handleCompareDate = (e) => {
    if (e.startDate !== null || e.endDate !== null) {
      setIsUpdate(true);
      setCompareDate(e);
    }
  }
  const handleBaseEmpty = (e) => {
   // setIsUpdate(true);
    //setBaseDate(null);
  }
  const handleComparEmpty = (e) => {
    setIsUpdate(true);
    setCompareDate(e);
  }

  const handleCurrentModule = (e) => {
    setIsUpdate(true);
    setCurrentModule(e);
  }

  return (
      <div>
        <Container>
          <Row>
            <Col md>
              <h2>{t("admin.report.h1")}</h2>
            </Col>
          </Row>
          <Row className="adminReportFilters">

            <Col md={4} className="adminReportDropdown">
              <h4>{t("admin.report.choMod")}</h4>
              <div className="dropdownWrap dropdownWrap-wide clearfix">
                <DropdownButton id="selectModuleDropdown" title={(currentModule?.descriptive_name[lang] || currentModule?.descriptive_name[availableLan[0]]) || "Select Module"} >
                  <Dropdown.Item
                    key={'COMPANY'}
                    title=''
                    eventKey="0"
                    role="menuitem"
                    onClick={(e) => handleCurrentModule({  ...company,id: "COMPANY", })}
                  >
                    {company.descriptive_name[lang] || company.descriptive_name[availableLan[0]]}
                  </Dropdown.Item>
                  {modules.map((group, key) => (
                    <Dropdown.Item
                      key={key}
                      title=''
                      eventKey={key}
                      role="menuitem"
                      onClick={(e) => handleCurrentModule(group)}
                    >
                      {group.descriptive_name[lang] || group.descriptive_name[availableLan[0]]}
                    </Dropdown.Item>
                  ))}
                </DropdownButton>
              </div>
            </Col>

            <Col md={4} className="adminReportDropdown adminReportDropdownAirbnb">
              <h4>{t("admin.common.timePeriod")}</h4>
              <div className="datePickerWrap datePickerWrapDesktop">
                <DatePicker onSelect={handleBaseDate} onEmpty={handleBaseEmpty} date={baseDate} />
              </div>
            </Col>

            <Col md={4} className="adminReportDropdown adminReportDropdownAirbnb" >
              <h4>{t("admin.common.compWith")}</h4>
              <div className="datePickerWrap1 datePickerWrapDesktop1">
                <DatePicker onSelect={handleCompareDate} onEmpty={handleComparEmpty} date={compareDate} />
              </div>
            </Col>

          </Row>

      </Container>
    </div>
  );
}

export default ModuleReportSelector;
